import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widgetBase';
import { take } from 'rxjs/operators';

/**
 * SocioEconomicData Widget
 */
@Component({
  selector: 'socio-economic-data-widget',
  templateUrl: './socio-economic-data-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './socio-economic-data-widget.component.scss']
})
export class SocioEconomicDataWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Reference list data
   */
  reflistDropDown = {};

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Current application mode (Edit/View) (obsolete?)
   */
  mode: string;

  /**
   * Current application localization (obsolete?)
   */
  appLocalization = 'de-DE';

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("socioEconomicData", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.mockupData$ = this.widgetService.loadMockup('socioEconomicData').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('socioEconomicData', this.getReport()).pipe();
  }

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'socioEconomicData', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.initWidgetConfig();
    this.widgetResized();

    this.widgetService.loadReflist('ref_l3_socio_economic_data_rating').subscribe((reflistsData: any) => {
      this.reflistDropDown['ref_l3_socio_economic_data_rating'] = reflistsData;
    });
  }


  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }
}
